import { render, staticRenderFns } from "./FilesPagination.vue?vue&type=template&id=e5a6df62&"
import script from "./FilesPagination.vue?vue&type=script&lang=js&"
export * from "./FilesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a6df62')) {
      api.createRecord('e5a6df62', component.options)
    } else {
      api.reload('e5a6df62', component.options)
    }
    module.hot.accept("./FilesPagination.vue?vue&type=template&id=e5a6df62&", function () {
      api.rerender('e5a6df62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/approvalFiles/FilesPagination.vue"
export default component.exports